import Decimal from 'decimal.js';
import { z } from 'zod';
export const MoneySchema = z
    .string()
    .refine((val) => {
    try {
        const d = new Decimal(val);
        return d.isFinite() && d.gte(0);
    }
    catch {
        return false;
    }
}, { message: 'Invalid money value: must be a non-negative decimal string' });
export const CurrencyCodeSchema = z.enum(['THB', 'USD', 'EUR', 'JPY', 'CNY', 'SGD']);
export const PeriodSchema = z.object({
    year: z.number().int().min(2020).max(2100),
    month: z.number().int().min(1).max(12),
});
export const IdempotencyKeySchema = z.uuid();
//# sourceMappingURL=common.js.map